import React from 'react';
import { Link } from 'react-router-dom';
import logo from './resources/OptiPathway_Horizontal_Transparent.png';
import './Header.css';

function Header() {
  return (
    <header className="app-header">
      <div className="logo-container">
        <Link to="/">
          <img src={logo} alt="OptiPathway Logo" className="logo" />
        </Link>
      </div>
      <nav>
        <Link to="/about">About</Link>
      </nav>
    </header>
  );
}

export default Header;
